import { defineEntityOwner } from './types';

export const loopOwnerDescriptor = defineEntityOwner('loop', {
  owningService: 'item-store',
  clientPackage: '@tempo-io/backend-item-store-client',
  cdcTopic: 'item-store-data-changes',
  resolveLink: (entityId, ctx) => `/org-id/${ctx.organizationId}/loop/${entityId}`,
  resolveLabels: null,
});

export const itemOwnerDescriptor = defineEntityOwner('item', {
  owningService: 'item-store',
  clientPackage: '@tempo-io/backend-item-store-client',
  cdcTopic: 'item-store-data-changes',
  resolveLink: (entityId, ctx) =>
    ctx.loopId != null
      ? `/org-id/${ctx.organizationId}/loop/${ctx.loopId}?jumpToItemId=${entityId}`
      : `/org-id/${ctx.organizationId}/all-items?jumpToItemId=${entityId}`,
  resolveLabels: null,
});
